"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.UK_PATH = void 0;
var UK_PATH = exports.UK_PATH = new Set(['/', 'blog', 'about-us', 'benefits', 'benefits-quiz', 'biosensor', 'doc', 'eula', 'fb-privacy-policy', 'fb-uk-terms-of-use', 'guide', 'harpers-bazaar', 'metabolism', 'nutrition', 'partcipant-agreement', 'privacy-notice', 'privacy-policy', 'profile', 'science', 'socialmedia-terms-of-use', 'terms-of-sale', 'terms-of-use', 'topic', 'weight-loss', 'womens-health']);
var _default = exports["default"] = UK_PATH;